import { render, staticRenderFns } from "./AddPhotoIcon.vue?vue&type=template&id=e2d75896&scoped=true"
import script from "./AddPhotoIcon.vue?vue&type=script&lang=js"
export * from "./AddPhotoIcon.vue?vue&type=script&lang=js"
import style0 from "./AddPhotoIcon.vue?vue&type=style&index=0&id=e2d75896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d75896",
  null
  
)

export default component.exports